import { html } from '@dom'

const component = () => html`<slot></slot>`

export default component
